export default "__VITE_ASSET__LdTRILta__"